import { render } from "./ToggleSwitch.vue?vue&type=template&id=786281f4&scoped=true&ts=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=786281f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786281f4"]])

export default __exports__